import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { RootState } from "lib/store"
import { Option } from "lib/types/common"

export interface NavigationFilters {
  fromDate: string
  toDate: string
  timeZone: string
  storeGroups: Option[]
  countries: Option[]
  discountRules: Option[]
  focusedDiscountRule: Option | null
  shippingMethods: Option[]
  campaignGroups: Option[]
  campaigns: Option[]
}

export interface OrderNavigation {
  discountCode?: string
  productId?: string
}

interface OrderState {
  orderLoading: boolean
  orderNavigation: OrderNavigation | null
  navigationFilters: NavigationFilters | null
}

const initialStateValue: OrderState = {
  orderLoading: false,
  orderNavigation: null,
  navigationFilters: null
}

const slice = createSlice({
  name: "order",
  initialState: initialStateValue,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.orderLoading = action.payload
      document.documentElement.classList.remove("sidebar-open")
    },
    setOrderNavigation: (
      state,
      action: PayloadAction<{ navigation: OrderNavigation; filters: NavigationFilters }>
    ) => {
      state.orderNavigation = action.payload.navigation
      state.navigationFilters = action.payload.filters
    },
    clearOrderNavigation: (state) => {
      state.orderNavigation = null
      state.navigationFilters = null
    }
  }
})

const { actions, reducer } = slice
export const { setLoading, setOrderNavigation, clearOrderNavigation } = actions
export const selectOrderNavigation = (state: RootState) => state.order.orderNavigation
export const selectNavigationFilters = (state: RootState) => state.order.navigationFilters

export default reducer
